import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getWatchedPages,
  addWatchedPages,
  deleteWatchedPages,
} from '../../../services/watched-pages/WatchedPagesService';

const WATCHED_PAGES_KEY = 'watched-pages';

export const useWatchedPages = (projectId: number, chatType?: string) => {
  return useQuery({
    queryKey: [WATCHED_PAGES_KEY, projectId, chatType],
    queryFn: () => getWatchedPages(projectId, chatType),
    enabled: !!projectId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useAddWatchedPages = (projectId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (urls: string[]) => addWatchedPages(projectId, urls),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WATCHED_PAGES_KEY, projectId] });
    },
  });
};

export const useDeleteWatchedPages = (projectId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: number[]) => deleteWatchedPages(projectId, ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WATCHED_PAGES_KEY, projectId] });
    },
  });
};
